import {provideSingleton, lazyInject} from './inversify';
import { ApiService } from './api_service';
import { ContextService } from './context_service';
import { DataService } from './data_service';
import { IDs } from '../core/IDs';


@provideSingleton(SystemOptionsService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service
export class SystemOptionsService {


    constructor() {
        this.onOptionsLoaded = this.onOptionsLoaded.bind(this);
    }
    private options: any = {};
    private debug = false;

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    init(callback: () => void) {
        this.loadOptions(callback);
    }

    getOptions(name: string) {
        return this.options[name] ? this.options[name].value : undefined;
    }
    setOption(name: string, value: any, callback?: () => void) {
        if (!this.options[name]) {
            this.options[name] = {tid: 0, value: value, name: name};
        } else {
            this.options[name].value = value;
        }
        if(this.debug) {
            console.log('Option set (' + name + '): ' , this.options[name]);
        }
        this.saveOption( this.options[name], callback);
    }
    loadOptions(callback: () => void) {
        this.dataService.loadDataForModul(IDs.ENT_SYSTEM_OPTIONS, {}, {}, IDs.MOD_CORE, (data) => this.onOptionsLoaded(data, callback));
    }
    onOptionsLoaded(data: any, callback: () => void) {
        if (data && data[IDs.ENT_SYSTEM_OPTIONS] && data[IDs.ENT_SYSTEM_OPTIONS].length > 0) {
            const res = data[IDs.ENT_SYSTEM_OPTIONS];
            res.forEach((option: any) => {
                let value = option.value;
                const name = option.name;
                const tid = option.tid;
                try {
                    value = JSON.parse(value);
                } catch (ex) {

                }
                this.options[name] = {name: name, tid: tid, value: value};
            });
        }
        if (this.debug) {
            console.log('Options loaded: ', this.options);
        }
        callback();
    }
    saveOption(option: any, callback?: (suc: boolean) => void) {
        const saveData = {
            tid: option.tid,
            name: option.name,
            value: option.value instanceof Object ? JSON.stringify(option.value) : option.value
        };
        const entityName = IDs.ENT_SYSTEM_OPTIONS;
        this.dataService.saveData(entityName, saveData, null, null, callback ? callback : (suc: boolean) => console.log('Gespeichert'));
    }
}
